import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { connect } from "react-redux"
import { Modal, Button, Divider } from 'antd'
import NormalLoginForm from "../Login/SignInForm";
import RegistrationForm from "../Login/RegistrationForm";
//import FacebookLogin from 'react-facebook-login';

class ModalLogin extends Component {
  state = {
    visible: false,
  }

  showModal = () => {
  this.setState({
    visible: true,
    redirect: false
  });
}

handleCancel = () => {
    this.setState({ visible: false });
  }

  render () {
    var displayLoginButton;
    if (this.props.user.login === true) {
      displayLoginButton = "none"
    }

    const { redirect } = this.state;
    if (redirect) {
      return <Redirect to='/profile' />;
    }
    return (
      <div display={displayLoginButton}>
        <Button type="primary" onClick={this.showModal}>Se connecter</Button>
        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>Retour</Button>
          ]}
        >
        <NormalLoginForm />

        <Divider/>
        <RegistrationForm />
        </Modal>
      </div>
    );
  }
}
/*
<h2 style={{textAlign: 'center'}}>ou</h2>
<div style={{marginLeft: '25%'}}>
  <FacebookLogin
    appId="527582624079253"
  autoLoad={true}
  textButton="Se connecter avec Facebook"
  cssClass="ant-btn ant-btn-fb"
  fields="name,email,picture"
  scope="public_profile,user_friends,user_link,user_gender,user_age_range"
  callback={this.responseFacebook}
  />
</div>*/

const mapStateToProps = (globalReducers) => (globalReducers);

const connectedModalLogin = connect(mapStateToProps, null)(ModalLogin);

export default connectedModalLogin;
